import { SearchExpression } from '../../model/search/advanced/SearchExpression';
import { ISearch } from '../../model/search/ISearch';

namespace app.services.search {

  export abstract class BaseSearchService {
    public abstract Search(project, collection: ICollection, expression: ISearch, columnFilters?: SearchExpression, sortBy?: string, sortDirection?: SortDirection, page?: number, limit?: number): Promise<any>;
  }
}

// ES6 export for modules that import BaseSearchService
export const BaseSearchService = app.services.search.BaseSearchService;
